import { ExamResultType } from '../../api/exam-result';
import { BLANK_TEXT } from '../../utils';

export type ExamResultsPropsType = {
  examResults: ExamResultType[];
};

function ExamResults({ examResults }: ExamResultsPropsType) {
  return (
    <div className='my-2 mx-auto w-full max-w-5xl'>
      <p className='my-6 text-center font-bold'>کارنامه تحلیلی به تفکیک درس</p>
      <table className='mx-auto w-full max-w-5xl table-auto'>
        <thead>
          <tr className='bg-sky-100 text-center'>
            <th className='border border-zinc-800 p-0.5 font-medium xs:p-1'>درس</th>
            <th className='border border-zinc-800 p-0.5 font-medium xs:p-1'>تعداد</th>
            <th className='border border-zinc-800 p-0.5 font-medium text-green-600 xs:p-1 xs:text-xl'>
              <span className='hidden xs:inline'>صحیح</span>
              <span className='xs:hidden'>ص</span>
            </th>
            <th className='border border-zinc-800 p-0.5 font-medium text-yellow-600 xs:p-1 xs:text-xl'>
              <span className='hidden xs:inline'>نزده</span>
              <span className='xs:hidden'>ن</span>
            </th>
            <th className='border border-zinc-800 p-0.5 font-medium text-red-600 xs:p-1 xs:text-xl'>
              <span className='hidden xs:inline'>غلط</span>
              <span className='xs:hidden'>غ</span>
            </th>
            <th className='border border-zinc-800 p-0.5 font-medium xs:p-1'>درصد</th>
            <th className='border border-zinc-800 p-0.5 font-medium xs:p-1'>تراز</th>
            <th className='border border-zinc-800 p-0.5 font-medium xs:p-1'>رتبه</th>
          </tr>
        </thead>
        <tbody>
          {examResults.map(
            ({
              id,
              lesson,
              correctQuestionCount,
              wrongQuestionCount,
              questionCount,
              score,
              rank,
              scaledScore
            }) => {
              const whiteQuestionCount = questionCount - correctQuestionCount - wrongQuestionCount;
              return (
                <tr key={id} className='hover:bg-sky-50'>
                  <td className='border border-zinc-800 text-center'>{lesson.name}</td>
                  <td className='border border-zinc-800 text-center'>{questionCount}</td>
                  <td className='border border-zinc-800 text-center'>{correctQuestionCount}</td>
                  <td className='border border-zinc-800 text-center'>{whiteQuestionCount}</td>
                  <td className='border border-zinc-800 text-center'>{wrongQuestionCount}</td>
                  <td dir='ltr' className='border border-zinc-800 text-center'>
                    <span>{score}</span>
                    <span className='hidden xs:inline'>%</span>
                  </td>
                  <td className='border border-zinc-800 text-center'>
                    {scaledScore || BLANK_TEXT}
                  </td>
                  <td className='border border-zinc-800 text-center'>{rank || BLANK_TEXT}</td>
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ExamResults;
